import React from 'react';
import { Controller } from 'react-hook-form';
import _ from 'lodash';
import clsx from 'clsx';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next';


export default function GroupSelect({accesses}) {
  const { t } = useTranslation();
  const methods = useFormContext()

  return (
    <>
      <span className='u-txt--label'>{t('administration.staff.groups.title')}</span><br />
      <Controller
        name='group_ids'
        control={methods.control}
        render={({ field: { onChange, value } }) => (
          <Select
            name='sp-group-select'
            className={clsx('o-select o-select--optgroup', { 'o-select--error': _.get(methods.formState.errors, 'group_ids') })}
            isMulti
            value={(accesses.data?.groups ?? []).filter(o => (value || []).includes(o.value))}
            onChange={(v) => {
              onChange(v.map(v => v.value));
            }}
            options={accesses.data?.groups ?? []}
          />
        )}
      />
      {methods.formState.errors.group_ids && (<p className='u-txt--error'>{methods.formState.errors.group_ids.message}</p>)}
      <p className='u-txt--label'>{t('administration.staff.groups.info')}</p>
    </>
  )
}

GroupSelect.propTypes = {
  accesses: PropTypes.object.isRequired,
};
